export enum NeoFacetSortByEnum {
    count = 'COUNT',
    value = 'VALUE',
    aggregate = 'AGGREGATE'
}
